import React  from 'react';
import __ from '../utils/translator';
import thronThumbnail from '../utils/thronThumbnail';
import ThemeCard from './ThemeCard';

import Container from './story-completion/Container';
import BackgroundImage from './story-completion/BackgroundImage';
import ContainerInner from './story-completion/ContainerInner';
import Title from './story-completion/Title';
import StoryCompletedIcon from './story-completion/StoryCompletedIcon';
import ThemeContainer from './story-completion/ThemeContainer';
import LinkButton from './LinkButton';
import thronThumbnailResize from '../utils/thronThumbnailResize';
import { withTheme } from 'styled-components';

function CollectionFirstThemeComponent({
  theme: scTheme,
  collectionFirstTheme: theme,
}) {
  return (
    <Container>
      <BackgroundImage src={thronThumbnailResize(thronThumbnail(scTheme.miscContentId.collectionFirstTheme), { height: 20 })} />

      <ContainerInner>
        <StoryCompletedIcon />

        <Title style={{ textAlign: 'center' }}>
          {__("Got the big picture? Now let’s go deeper")}
        </Title>

        <ThemeContainer>
          <ThemeCard
            related
            key={theme.id}
            theme={theme}
            status={theme.status} />
        </ThemeContainer>

        <LinkButton
          style={{ marginTop: '2rem', }}
          onClick={() => window.scrollTo(0, 0)}
          color="secondary"
          size="large"
          to={`/seasonal/${theme.collectionId}/themes`}>
          {__("Check all the collection themes")}
        </LinkButton>
      </ContainerInner>
    </Container>
  );
}

/**
 * The sole purpose of this component is to allow the use of the "theme" prop
 * while also injecting the StyledComponent theme. The component saves the value
 * of "theme" and then injects the StyledComponent's theme. The real component
 * then renames the two into "theme" and "scTheme".
 *
 * @param theme
 * @param props
 * @returns {*}
 * @constructor
 */
export default function CollectionFirstTheme({ theme, ...props }) {
  const Component = withTheme(CollectionFirstThemeComponent);

  return (
    <Component collectionFirstTheme={theme} {...props} />
  );
}
